export default "__VITE_ASSET__DEzM5hcY__"